export default "__VITE_ASSET__q7an4ZKd__"